// import Swiper from 'swiper';
// console.log('Load from front page');
var swiper = new Swiper('.swiper-container', {
   direction: 'vertical',
   parallax: true,
   pagination: {
      el: '.swiper-pagination',
      clickable: true,
   },
   autoplay: {
      delay: 6500,
      disableOnInteraction: false,
   },
});



var startScroll, touchStart, touchCurrent;
swiper.slides.on('touchstart', function (e) {
    startScroll = this.scrollTop;
    touchStart = e.targetTouches[0].pageY;
}, true);
swiper.slides.on('touchmove', function (e) {
    touchCurrent = e.targetTouches[0].pageY;
    var touchesDiff = touchCurrent - touchStart;
    var slide = this;
    var onlyScrolling =
            ( slide.scrollHeight > slide.offsetHeight ) && //allow only when slide is scrollable
            (
                ( touchesDiff < 0 && startScroll === 0 ) || //start from top edge to scroll bottom
                ( touchesDiff > 0 && startScroll === ( slide.scrollHeight - slide.offsetHeight ) ) || //start from bottom edge to scroll top
                ( startScroll > 0 && startScroll < ( slide.scrollHeight - slide.offsetHeight ) ) //start from the middle
            );
    if (onlyScrolling) {
        e.stopPropagation();
    }
}, true);


// resising
let slide = document.querySelector('.swiper-slide');
let wrapper = document.getElementById('wrapper');

function setHeightOnResize(slide) {
    console.log(slide);
   slide.style.height = 'auto';
   wrapper.style.height = 'auto';
   let newHeight = slide.offsetHeight;
   wrapper.style.height = newHeight + 'px';
}
function resetSize() {
   wrapper.style.height = '440px';
}

window.onload = function () {
   let slide = document.querySelector('.swiper-slide');
   let viewportWidth = window.innerWidth;
   if (viewportWidth <= 769) {
      setHeightOnResize(slide);
   } else {
      resetSize();
   }
}

window.onresize = function () {
   let slide = document.querySelector('.swiper-slide');
   let viewportWidth = window.innerWidth;
   if (viewportWidth <= 769) {
      setHeightOnResize(slide);
   } else {
      resetSize();
   }
};
